<template>
	<div>
		<home-header></home-header>
		<div class="home-wrap">
			<page01 class="home-page"></page01>
			<page02 class="home-page"></page02>
			<page03 class="home-page"></page03>
			<page04 class="home-page"></page04>
			<page05 class="home-page"></page05>
			<page06 class="home-page"></page06>
			<page07 class="home-page"></page07>
		</div>
		<play-video :show="videoShow" :videoUrl="videoUrl"></play-video>
		<news-mask :show="newsShow"></news-mask>
		<to-top></to-top>
	</div>
	
</template>

<script>
import "../../plugins/fullpage.min.js";

import header from "./header.vue";
import page01 from "./page01.vue";
import page02 from "./page02.vue";
import page03 from "./page03.vue";
import page04 from "./page04.vue";
import page05 from "./page05.vue";
import page06 from "./page06.vue";
import page07 from "./page07.vue";
import playVideo from "../../components/play-video.vue";
import newsMask from "../../components/news-mask.vue";
import toTop from "../../components/to-top";

export default {
    name: "main-page",
    components: {
		page01,
		page02,
		page03,
		page04,
		page05,
		page06,
		page07,
		"homeHeader": header,
		"playVideo": playVideo,
		"toTop": toTop,
		"newsMask": newsMask,
	},
    data: () => ({
		fullpage: null,
		preloadImg: [
			// page02
			require("../../assets/images/home/page02/news_mask_bg.png"),
			require("../../assets/images/home/page02/news_mask_icon.png"),
			// page04
			require("../../assets/images/home/page04/character01/character01_static.png"),
			require("../../assets/images/home/page04/character01/character01.png"),
			require("../../assets/images/home/page04/character01/character_details.png"),
			require("../../assets/images/home/page04/character01/class.png"),
			require("../../assets/images/home/page04/character01/cv.png"),
			require("../../assets/images/home/page04/character01/modal_bg.png"),
			require("../../assets/images/home/page04/character01/name.png"),
			require("../../assets/images/home/page04/character01/word.png"),

			require("../../assets/images/home/page04/character02/character02_static.png"),
			require("../../assets/images/home/page04/character02/character02.png"),
			require("../../assets/images/home/page04/character02/character_details.png"),
			require("../../assets/images/home/page04/character02/class.png"),
			require("../../assets/images/home/page04/character02/cv.png"),
			require("../../assets/images/home/page04/character02/modal_bg.png"),
			require("../../assets/images/home/page04/character02/name.png"),
			require("../../assets/images/home/page04/character02/word.png"),
	
			require("../../assets/images/home/page04/character03/character03_static.png"),
			require("../../assets/images/home/page04/character03/character03.png"),
			require("../../assets/images/home/page04/character03/character_details.png"),
			require("../../assets/images/home/page04/character03/class.png"),
			require("../../assets/images/home/page04/character03/cv.png"),
			require("../../assets/images/home/page04/character03/modal_bg.png"),
			require("../../assets/images/home/page04/character03/name.png"),
			require("../../assets/images/home/page04/character03/word.png"),
			
			require("../../assets/images/home/page04/character04/character04_static.png"),
			require("../../assets/images/home/page04/character04/character04.png"),
			require("../../assets/images/home/page04/character04/character_details.png"),
			require("../../assets/images/home/page04/character04/class.png"),
			require("../../assets/images/home/page04/character04/cv.png"),
			require("../../assets/images/home/page04/character04/modal_bg.png"),
			require("../../assets/images/home/page04/character04/name.png"),
			require("../../assets/images/home/page04/character04/word.png"),
			
			require("../../assets/images/home/page04/character05/character05_static.png"),
			require("../../assets/images/home/page04/character05/character05.png"),
			require("../../assets/images/home/page04/character05/character_details.png"),
			require("../../assets/images/home/page04/character05/class.png"),
			require("../../assets/images/home/page04/character05/cv.png"),
			require("../../assets/images/home/page04/character05/modal_bg.png"),
			require("../../assets/images/home/page04/character05/name.png"),
			require("../../assets/images/home/page04/character05/word.png"),

			require("../../assets/images/home/page04/character06/character06_static.png"),
			require("../../assets/images/home/page04/character06/character06.png"),
			require("../../assets/images/home/page04/character06/character_details.png"),
			require("../../assets/images/home/page04/character06/class.png"),
			require("../../assets/images/home/page04/character06/cv.png"),
			require("../../assets/images/home/page04/character06/modal_bg.png"),
			require("../../assets/images/home/page04/character06/name.png"),
			require("../../assets/images/home/page04/character06/word.png"),

			require("../../assets/images/home/page04/character07/character07_static.png"),
			require("../../assets/images/home/page04/character07/character07.png"),
			require("../../assets/images/home/page04/character07/character_details.png"),
			require("../../assets/images/home/page04/character07/class.png"),
			require("../../assets/images/home/page04/character07/cv.png"),
			require("../../assets/images/home/page04/character07/modal_bg.png"),
			require("../../assets/images/home/page04/character07/name.png"),
			require("../../assets/images/home/page04/character07/word.png"),

			require("../../assets/images/home/page04/coming.png"),
			// page05
			require("../../assets/images/home/page05/text_01.png"),
			require("../../assets/images/home/page05/text_02.png"),
			require("../../assets/images/home/page05/text_03.png"),
			require("../../assets/images/home/page05/text_04.png"),
			require("../../assets/images/home/page05/text_05.png"),
			// page06
			require("../../assets/images/home/page06/01_cg.png"),
			require("../../assets/images/home/page06/02_cg.png"),
			require("../../assets/images/home/page06/03_cg.png"),
			require("../../assets/images/home/page06/04_cg.png"),
			require("../../assets/images/home/page06/05_cg.png"),
			require("../../assets/images/home/page06/06_cg.png"),
			require("../../assets/images/home/page06/07_cg.png"),
		],
	}),
    created() {
		// 请求yotube地址
		this.axios.get(`${process.env.VUE_APP_HOST}/yts`).then(v => {
			// console.log(v.data)
			if(v.data.code == 20000) {
				this.$store.commit("SET_YOUTUBEURL", {
					world: v.data.data.WORLD?v.data.data.WORLD.link:'',
					system: v.data.data.SYSTEM?v.data.data.SYSTEM.link:'',
				})
			}
		}).catch(e => {
			console.log(e)
		})

		// 预加载图片
		this.$utils.perLoadImg(this.preloadImg, 1, (percent) => {});
	},
    mounted() {
		this.fullpage = new FullPage({
			containerClassName: ".home-wrap",
			pageClassName: ".home-page",
			disableSrcollClassName: ['new-box__itembox', 'new-box__item', 'new_other', 'new_other--time', 'new_other--type', 'new_title']
		})
		this.fullpage.init()
		this.$store.commit("INIT_HOME_FULLPAGE", this.fullpage);
		// 
		let newsID = this.$route.query['news-id']
		if(newsID) {
			this.fullpage.goTo(2)

			this.axios.get(`${process.env.VUE_APP_HOST}/news/detail`, {
				params: {
					id: newsID
				}
			}).then(v => {
				if(v.data.data.total > 0) {
					this.$store.commit("SET_NEWS", {
						status: true,
						content: v.data.data.items[0]
					});
				}
			}).catch(e => {
				console.log(e)
			})
		}
	},
    watch: {
	},
    computed: {
		videoUrl() {
			return this.$store.state.VIDEO_URL;
		},
		videoShow() {
			return this.$store.state.VIDEO_SHOW;
		},
		newsShow() {
			return this.$store.state.NEWS_SHOW;
		}
	},
    methods: {}
};
</script>

<style lang="scss" scoped>
.home-wrap {
	.home-page {
		height: 100%;
	}
}
</style>